import { Component, OnInit } from '@angular/core';
import { AppService } from '../../app.service';
import { Product } from "../../app.models";

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  public slides = [
    {
      title: 'Plough',
      subtitle: 'Special for today',
      image: 'assets/images/Plough.jpg',
      desc: 'This plough is designed to work in all soil type conditions providing primary tillage with weed management.'
    },
    {
      title: 'Rotary Tiller',
      subtitle: 'Special for today',
      image: 'assets/images/RotaryTiller.jpg',
      desc: 'This rotery tiller works both as primary and secondary tillage implement based on crop and soil type.'
    },
    {
      title: 'Cultivator',
      subtitle: 'New Arrivals On Sale',
      image: 'assets/images/Cultivator.jpg',
      desc: 'This cultivator is heavy duty build that is designed to pulverise the soil for seed bed.'
    }

  ];

  public brands = [];
  public banners = [];
  public featuredProducts: any = [];
  public onSaleProducts: [Array<Product>];
  public topRatedProducts: Array<Product>;
  public newArrivalsProducts: Array<Product>;


  constructor(public appService: AppService) { }

  ngOnInit() {
    this.getBanners();
    this.getProducts("featured");
    this.getBrands();
  }

  public onLinkClick(e) {
    this.getProducts(e.tab.textLabel.toLowerCase());
  }

  public getProducts(type) {
    if (type == "featured" && !this.featuredProducts) {
      this.appService.getProducts("featured").subscribe(data => {
        //this.featuredProducts = data;      
      })
    }
    if (type == "on sale" && !this.onSaleProducts) {
      this.appService.getProducts("on-sale").subscribe(data => {
        //this.onSaleProducts = data;      
      })
    }
    if (type == "top rated" && !this.topRatedProducts) {
      this.appService.getProducts("top-rated").subscribe(data => {
        //this.topRatedProducts = data;      
      })
    }
    if (type == "new arrivals" && !this.newArrivalsProducts) {
      this.appService.getProducts("new-arrivals").subscribe(data => {
        // this.newArrivalsProducts = data;      
      })
    }
    else {
      this.appService.getProducts("/api/Product/GetProductByUserStateId").subscribe(data => {

        this.featuredProducts = data;
      })
    }
  }

  public getBanners() {
    this.appService.getBanners().subscribe(data => {
      this.banners = data;
    })
  }

  public getBrands() {
    this.brands = this.appService.getBrands();
  }

}
